import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { Subject } from 'rxjs';
import { FilterMetadata } from 'lib/ng-data-table';
import { formatLocalToDBTZDate, SelectItem } from 'lib/common';
import { FILE } from 'dns';
//https://medium.com/@MatheusCAS/injecting-a-service-into-another-service-in-angular-3b253df5c21
@Injectable({
  providedIn: 'root'
})
export class CommonFilterService {

  private TSTypeSource = new BehaviorSubject(1);
  TSType = this.TSTypeSource.asObservable();

  private TSBetweenSource = new BehaviorSubject('');
  TSBetween = this.TSBetweenSource.asObservable();//Used in headers by setting in respective service of a comp and passing to other components as recent date selection from the same respective service
  startDate: Date;
  endDate: Date;

  //Refresh
  //https://medium.com/beingcoders/angular-basics-refresh-an-angular-component-without-reloading-the-same-component-b6c513f06fb2
  private componentMethodCallSource = new Subject<any>();
  componentMethodCalled$ = this.componentMethodCallSource.asObservable();
  //Auto-refresh
  private componentMethodWithArgCallSource: BehaviorSubject<any> = new BehaviorSubject({ AutoRefSelected: 5 * 1000, AutoRefStop: true });
  componentMethodWithArgCalled$ = this.componentMethodWithArgCallSource.asObservable();

  private componentFilterMethodCallSource = new Subject<any>();
  componentFilterMethodCalled$ = this.componentFilterMethodCallSource.asObservable();
  private componentFilterMethodSavedCallSource = new Subject<any>();
  componentFilterMethodSavedCalled$ = this.componentFilterMethodSavedCallSource.asObservable();

  private componentCRMethodCallSource = new Subject<any>();
  componentCRMethodCalled$ = this.componentCRMethodCallSource.asObservable();
  private componentCRMethodSavedCallSource = new BehaviorSubject<any>('');
  componentCRMethodSavedCalled$ = this.componentCRMethodSavedCallSource.asObservable();

  private componentRegionMethodCallSource = new Subject<any>();
  componentRegionMethodCalled$ = this.componentRegionMethodCallSource.asObservable();
  private componentRegionMethodSavedCallSource = new BehaviorSubject<any>('');
  componentRegionMethodSavedCalled$ = this.componentRegionMethodSavedCallSource.asObservable();

  private componentAudioStatsMethodCallSource = new Subject<any>();
  componentAudioStatsMethodCalled$ = this.componentAudioStatsMethodCallSource.asObservable();
  private componentAudioMethodSavedCallSource = new BehaviorSubject<any>(0);
  componentAudioMethodSavedCalled$ = this.componentAudioMethodSavedCallSource.asObservable();
  private componentVoiceStatsMethodCallSource = new Subject<any>();
  componentVoiceStatsMethodCalled$ = this.componentVoiceStatsMethodCallSource.asObservable();
  private componentVoiceMethodSavedCallSource = new BehaviorSubject<any>(0);
  componentVoiceMethodSavedCalled$ = this.componentVoiceMethodSavedCallSource.asObservable();

  private componentGMapsMethodCallSource = new Subject<any>();
  componentGMapsMethodCalled$ = this.componentGMapsMethodCallSource.asObservable();
  private componentGMapsMethodSavedCallSource = new BehaviorSubject<any>(0);
  componentGMapsMethodSavedCalled$ = this.componentGMapsMethodSavedCallSource.asObservable();

  private isFilters = new BehaviorSubject(false);
  isFilters$ = this.isFilters.asObservable();
  private nonFilterScreen = new BehaviorSubject(false);
  nonFilterScreen$ = this.nonFilterScreen.asObservable();
  //private isOpenPanel = new Subject<boolean>();
  //isOpenPanel$ = this.isOpenPanel.asObservable();

  private DB_TZSource = new BehaviorSubject(-500);
  DB_TZ = this.DB_TZSource.asObservable();
  private DB_BRDiffSource = new BehaviorSubject(-500);
  DB_BRDiff = this.DB_BRDiffSource.asObservable();

  //private TSRangeSelectedSource = new BehaviorSubject('10min');
  //TSRangeSelected = this.TSRangeSelectedSource.asObservable();
  
  private TSRangeFilterSource: BehaviorSubject<any> = new BehaviorSubject({ RangeType: '10min', RangeSelected: 'Last 10 Minutes'});
  TSRangeFilter = this.TSRangeFilterSource.asObservable();

  //https://stackoverflow.com/questions/49525637/add-data-to-the-end-of-a-behavior-object-array-angular-5/49525730
  private GeneralFilterSource: BehaviorSubject<FilterMetadata> = new BehaviorSubject({} as FilterMetadata);
  //private GeneralFilterSource: Subject<FilterMetadata> = new Subject();
  GeneralFilter = this.GeneralFilterSource.asObservable();

  private GeneralFilterDFSource: BehaviorSubject<FilterMetadata> = new BehaviorSubject({} as FilterMetadata);
  //private GeneralFilterDFSource: Subject<FilterMetadata> = new Subject();
  GeneralFilterDF = this.GeneralFilterDFSource.asObservable();

  private GeneralEventIDFilterSource: BehaviorSubject<FilterMetadata> = new BehaviorSubject({} as FilterMetadata);
  //private GeneralEventIDFilterSource: Subject<FilterMetadata> = new Subject();
  GeneralEventIDFilter = this.GeneralEventIDFilterSource.asObservable();

  private AllGeneralFilterSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  //private AllGeneralFilterSource = new Subject<Array<any>>();
  AllGeneralFilter = this.AllGeneralFilterSource.asObservable();

  //private DeleteFilterSource: BehaviorSubject<string> = new BehaviorSubject('');
  private DeleteFilterSource = new Subject<string>();
  DeleteFilter = this.DeleteFilterSource.asObservable();

  private ClearAllFiltersSource = new Subject<any>();
  ClearAllFilters = this.ClearAllFiltersSource.asObservable();

  //// MainFilter value --elumalai
  private MainFilterID = new BehaviorSubject(0);
  mainFilterID = this.MainFilterID.asObservable();

  SetMainFilter(ID) {
    this.MainFilterID.next(ID);
  }

  ////SET SELECTED CUSTOM REPORTID IN CONFIGURATION SCREEN ON LOAD --ELUMALAI
  private CustomReportID = new BehaviorSubject(0);
  customReportID_Config = this.CustomReportID.asObservable();

  SetCustomReportID(ID) {
    this.CustomReportID.next(ID);
  }

  ////SET SELECTED CUSTOM REPORTID IN CONFIGURATION SCREEN ON LOAD --ELUMALAI
  private GMapConfigID = new BehaviorSubject(0);
  gmapID_Config = this.GMapConfigID.asObservable();

  SetGmapConfigID(ID) {
    this.GMapConfigID.next(ID);
  }

  ////SET SELECTED REGION IN CONFIGURATION SCREEN ON LOAD --ELUMALAI
  private GMapRegion = new BehaviorSubject("0");
  gmapRegion_Config = this.GMapRegion.asObservable();

  SetGmapRegion(name) {
    this.GMapRegion.next(name);
  }

  ////Set/Get  MainFilter CriteriaName --elumalai
  private MainFilterCriteriaName = new BehaviorSubject('');
  mainFilter_CriteriaName = this.MainFilterCriteriaName.asObservable();

  SetMainFilterCriteriaName(crName) {
    this.MainFilterCriteriaName.next(crName);
  }

  ////////////////////////Set/Get  MainFilter MapRegionName --elumalai
  private MainFilterRegionName = new BehaviorSubject('');
  mainFilter_MapRegionName = this.MainFilterRegionName.asObservable();

  SetMainFilterMapRegion(mapregionName) {
    this.MainFilterRegionName.next(mapregionName);
  }

  //// MainFilter CustomDate value --elumalai
  private MainFilter_ContainsCustDate = new BehaviorSubject(false);
  mainFilter_ContainsCustDate = this.MainFilter_ContainsCustDate.asObservable();

  SetMainFilterCustomDate(value) {
    this.MainFilter_ContainsCustDate.next(value);
  }

  ////ITs file value --elumalai
  private ITS_fileValue = new BehaviorSubject<any[]>(null);  //private ITS_fileValue = new BehaviorSubject<File[]>(null);
  ITSValue = this.ITS_fileValue.asObservable();

  SetITSFile(value) {
    this.ITS_fileValue.next(value);
  }

  ////GMap Restore Previous selected DispalyOption onPageLoad --elumalai
  private GmapDisplayOptionRestore = new BehaviorSubject<any>(null);
  displayOptionValues = this.GmapDisplayOptionRestore.asObservable();

  SetGMapDisplayOption(value) {
    this.GmapDisplayOptionRestore.next(value);
  }

  //PageNumber: number;
  //RecordsPerPage: number;
  //Sort: string;
  private PaginationFilterSource: BehaviorSubject<any> = new BehaviorSubject({ PageNumber: 1, RecordsPerPage: 200, Sort: '' });
  PaginationFilter = this.PaginationFilterSource.asObservable();
  //Using Subject wont be called mutiple times like BehaviourSubject. But at the same time subject cannot hold value more than once (constantly) like BehaviourSubject - IMP
  //https://upmostly.com/angular/subject-vs-replaysubject-vs-behaviorsubject
  //https://codehandbook.org/subscribe-callback-called-multiple-times/
  //https://stackoverflow.com/questions/43348463/what-is-the-difference-between-subject-and-behaviorsubject
  //https://satyapriyamishra111.medium.com/all-you-need-to-know-about-async-subject-2cd72ea646ea
  private _PaginationListners = new Subject<any>();
  PaginationListners = this._PaginationListners.asObservable();
  ListenPaging() {
    this._PaginationListners.next();
  }

  private _listners = new Subject<any>();
  listen = this._listners.asObservable();
  filter(listenNext) {
    this._listners.next(listenNext);
  }

  private _columnToggleListners = new BehaviorSubject<SelectItem[]>([]);
  columnToggleListen = this._columnToggleListners.asObservable();
  columnToggleIndices(listenNext) {
    this._columnToggleListners.next(listenNext);
  }

  //GMaps predefned config ON/OFF
  private usePredefinedConfigSource = new BehaviorSubject('OFF');
  usePredefinedConfig = this.usePredefinedConfigSource.asObservable(); 

  ////////////
  private filterCEErrorEvent = new BehaviorSubject(false);
  filterCallEventErrorEvent = this.filterCEErrorEvent.asObservable();
  private filterConnDropEvent = new BehaviorSubject(false);
  filterConnDrop = this.filterConnDropEvent.asObservable();

  //Default values set here
  constructor() {
    this.setDates("10|m");
    this.TSTypeSource.next(1);
  }

  //Latest TS and date range selected
  setProperties(TSSelected: number, TimeSelected: string) {
  //setProperties(TimeSelected: string) {
    this.TSTypeSource.next(TSSelected);
    if (TimeSelected !== "")
      this.setDates(TimeSelected);
  }

  //Refresh
  basicRefresh() {
    this.componentMethodCallSource.next();
  }
  //Auto-Refresh
  basicAutoRefresh(AutoRefreshInfo: any) {
    this.componentMethodWithArgCallSource.next(AutoRefreshInfo);
  }

  basicFilterRefresh(type: number) {
    this.componentFilterMethodCallSource.next(type);
  }
  basicFilterSavedRefresh() {
    this.componentFilterMethodSavedCallSource.next();
  }

  basicCRRefresh(type: string) {
    this.componentCRMethodCallSource.next(type);
  }

  basicRegionRefresh(type: string) {
    this.componentRegionMethodCallSource.next(type);
  }

  basicCRSavedRefresh(type: string) {
    this.componentCRMethodSavedCallSource.next(type);
  }

  basicRegionSavedRefresh(type: string) {
    this.componentRegionMethodSavedCallSource.next(type);
  }

  basicAudioStatsConfigRefresh() {
    this.componentAudioStatsMethodCallSource.next();
  }
  basicAudioSavedRefresh(type: number) {
    this.componentAudioMethodSavedCallSource.next(1);
  }
  basicVoiceStatsConfigRefresh() {
    this.componentVoiceStatsMethodCallSource.next();
  }
  basicVoiceSavedRefresh(type: number) {
    this.componentVoiceMethodSavedCallSource.next(1);
  }

  basicGMapsRefresh(type: number) {
    this.componentGMapsMethodCallSource.next(type);
  }
  basicGMapsSavedRefresh(type: number) {
    this.componentGMapsMethodSavedCallSource.next(type);
  }

  setIsFilters(boolValue: boolean) {
    this.isFilters.next(boolValue);
  }
  setNonFiltersScreen(boolValue: boolean) {
    this.nonFilterScreen.next(boolValue);
  }
  //setIsOpenPanel(boolValue: boolean) {
  //  this.isOpenPanel.next(boolValue);
  //}

  //Latest start and end Dates for Title component
  setDatesProperties(TimeSelected: string) {
    this.TSBetweenSource.next(TimeSelected);
  }
  ////Type of Date range selected for internal calculation in service
  //setDatesRangeProperties(RangeSelected: string) {
  //  this.TSRangeSelectedSource.next(RangeSelected);
  //}
  setDBTZFromVarCol(Timezone_GMT: number) {
    this.DB_TZSource.next(Timezone_GMT);
  }
  setDBAndBrowserHrsDiff(hoursDiff: number) {
    this.DB_BRDiffSource.next(hoursDiff);
  }

  private MainFilterCustDT = new BehaviorSubject('');
  mfDateTime = this.MainFilterCustDT.asObservable();
  setMFCustDT(TimeSelected: string) {
    this.MainFilterCustDT.next(TimeSelected);
  }

  private MainFilterTZON = new BehaviorSubject(0);
  mfTZ = this.MainFilterTZON.asObservable();
  setMFTZON(TZSelected: number) {
    this.MainFilterTZON.next(TZSelected);
  }

  //Type of Dates range used in demo service curretn date filter setting and Title - IMP
  setRangeFilterData(data) {
    this.TSRangeFilterSource.next(data);
  }
  //Filtered columns details used in Synopsis
  setGeneralFilterData(data) {
    this.GeneralFilterSource.next(data);
  }
  setGeneralFilterDFData(data) {
    this.GeneralFilterDFSource.next(data);
  }
  setGeneralEventIDFilterData(data) {
    this.GeneralEventIDFilterSource.next(data);
  }
  setAllGeneralFilterData(data) {
    this.AllGeneralFilterSource.next(data);
  }
  setDeleteFilterData(data) {
    this.DeleteFilterSource.next(data);
  }
  setClearAllFiltersData() {
    this.ClearAllFiltersSource.next();
  }
  setPaginationFilterData(data) {
    this.PaginationFilterSource.next(data);
  }

  setUsePredefinedConfigData(data) {
    this.usePredefinedConfigSource.next(data);
  }

  setCallEventErrorEvent(data) {
    this.filterCEErrorEvent.next(data);
  }
  setConnDropEvent(data) {
    this.filterConnDropEvent.next(data);
  }

  setDates(periodDiff) {
    //console.log(periodDiff)
    if (periodDiff == "10|m") {
      let dt = new Date();
      let dbTz = -500;
      this.DB_TZ.toPromise().then(res => {
        dbTz = res;
      });
      let dbAndBrHrs = -500;
      this.DB_BRDiff.toPromise().then(res => {
        dbAndBrHrs = res;
      });
      if (dbAndBrHrs != -500)
        dt = formatLocalToDBTZDate(new Date(), dbTz, dbAndBrHrs);
      //console.log(dt)

      this.endDate = new Date();
      this.startDate = new Date();

      this.calcPeriod(periodDiff);

      this.endDate.setMinutes(this.endDate.getMinutes() + 3);//Grace time

      let starthours = this.startDate.getHours().toString();
      starthours = ("0" + starthours).slice(-2);
      let endhours = this.endDate.getHours().toString();
      endhours = ("0" + endhours).slice(-2);
      let startmins = this.startDate.getMinutes().toString();
      startmins = ("0" + startmins).slice(-2);
      let endmins = this.endDate.getMinutes().toString();
      endmins = ("0" + endmins).slice(-2);

      let startmon = (this.startDate.getMonth() + 1).toString();
      startmon = ("0" + startmon).slice(-2);
      let endmon = (this.endDate.getMonth() + 1).toString();
      endmon = ("0" + endmon).slice(-2);
      let startdate = this.startDate.getDate().toString();
      startdate = ("0" + startdate).slice(-2);
      let enddate = this.endDate.getDate().toString();
      enddate = ("0" + enddate).slice(-2);
      let startDateFinal = startmon + "/" + startdate + "/" + this.startDate.getFullYear() + " " + starthours + ":" + startmins + ":00";
      let endDateFinal = endmon + "/" + enddate + "/" + this.endDate.getFullYear() + " " + endhours + ":" + endmins + ":00";

      this.TSBetweenSource.next(startDateFinal + '^' + endDateFinal);
    }
    else {
      //this.TSBetweenSource.next(periodDiff.replace(' - ', ':00^') + ":00");//replace seperator with adding 00secs to both start and end dates by default
      this.TSBetweenSource.next(periodDiff.replace(' - ', '^'));//replace seperator with ^
    }
  }

  //Only 10|m
  calcPeriod(periodDiff) {
    if (periodDiff == "today") {
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);
    }
    else if (periodDiff == "yesterday") {
      this.startDate.setDate(this.startDate.getDate() - 1);
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);

      this.endDate.setDate(this.startDate.getDate());
      this.endDate.setHours(23);
      this.endDate.setMinutes(56);
    }
    else {
      let periodVal = (periodDiff.split("|"))[0];
      let periodType = (periodDiff.split("|"))[1];
      switch (periodType) {
        case "m":
          this.startDate.setMinutes(this.startDate.getMinutes() - periodVal);
          break;
        case "h":
          this.startDate.setHours(this.startDate.getHours() - periodVal);
          break;
        case "d":
          this.startDate.setDate(this.startDate.getDate() - periodVal);
          break;
      }
    }
  }
}
